import React, { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ChangelogFeed from '../../../components/changelog/ChangelogFeed';
import { planInfo, planOrderFromName } from '../../../components/changelog/changelogConfig';
import PlanUpgradeModal from '../../../components/subscription/PlanUpgradeModal';
import { useSubscription } from '../../../contexts/SubscriptionContext';
import styles from './ChangelogPage.module.css';

/**
 * Novidades da Gabriela (usuário logado): o que mudou no produto, por semana.
 * Lê as novidades publicadas do catálogo (useChangelog); "Ver na tela" leva à funcionalidade.
 *
 * Selo de plano é vitrine: aparece quando o plano atual não inclui a novidade (no trial
 * ou com plano desconhecido aparece sempre) e abre o atalho de mudança de plano.
 */
const ChangelogPage = () => {
  const navigate = useNavigate();
  const { subscription, isInActiveTrial } = useSubscription();
  const [upgradeEntry, setUpgradeEntry] = useState(null);

  const currentOrder = isInActiveTrial() ? null : planOrderFromName(subscription?.plan_name);

  const cardProps = useCallback((entry) => {
    const required = planInfo(entry.plan);
    const showPlan = Boolean(required) && (currentOrder === null || currentOrder < required.order);
    return {
      showPlan,
      onPlanClick: setUpgradeEntry,
      onOpenScreen: (link) => navigate(link),
    };
  }, [currentOrder, navigate]);

  return (
    <div className={styles.page}>
      <div className={styles.header}>
        <h1 className={styles.title}>Novidades</h1>
        <p className={styles.subtitle}>O que mudou na Gabriela, semana a semana.</p>
      </div>

      <ChangelogFeed cardProps={cardProps} />

      <PlanUpgradeModal
        isOpen={Boolean(upgradeEntry)}
        onClose={() => setUpgradeEntry(null)}
        featureName={upgradeEntry?.title || ''}
        type="permission"
        planName={planInfo(upgradeEntry?.plan)?.name}
      />
    </div>
  );
};

export default ChangelogPage;
